/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Stat_CopiesInputs */

const en_fw_guide_stat_copies = /** @type {(inputs: Fw_Guide_Stat_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manga copies in print`)
};

const zh_fw_guide_stat_copies = /** @type {(inputs: Fw_Guide_Stat_CopiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`漫画累计发行量`)
};

/**
* | output |
* | --- |
* | "Manga copies in print" |
*
* @param {Fw_Guide_Stat_CopiesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_stat_copies = /** @type {((inputs?: Fw_Guide_Stat_CopiesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Stat_CopiesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_stat_copies(inputs)
	return zh_fw_guide_stat_copies(inputs)
});
export { fw_guide_stat_copies as "fw.guide.stat.copies" }